import { getSrcs } from '@helpers/image';
import { getSvgFromSystem, SystemIcon } from '@helpers/systemIcons';
import { withMotion } from '@hoc/withMotion';
import SocialMediaLinks from '@stories/Components/SocialMediaLinks/SocialMediaLinks';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from '../Header.styles';
import IllustratedCard from '@stories/Components/Cards/IllustratedCard/IllustratedCard';
const MobileNavigation = (props) => {
    const [activeId, setActiveId] = React.useState('');
    if (!props.links) {
        return null;
    }
    const handleActivateChange = (id) => {
        if (id) {
            setActiveId(id);
        }
        else {
            setActiveId('');
        }
    };
    return (React.createElement(S.MobileNav, { "data-is-open": props.open },
        React.createElement(S.MobileNavInner, null, props.links.map((link) => (React.createElement(NavLink, { key: link.id, activeId: activeId, onActivateChange: handleActivateChange, ...link })))),
        React.createElement(S.MobileNavBottom, null,
            React.createElement(S.TrustPilotLogoMobileNavTray, null),
            props.socialMediaLinks && React.createElement(SocialMediaLinks, { ...props.socialMediaLinks, theme: "dark" }))));
};
const NavLink = (props) => {
    const srcs = props.featuredImage?.src && getSrcs(props.featuredImage, 988, 344, 4, 2 / 4);
    const hasSecondLevel = (props.sectionLinks && props.sectionLinks.length > 0) ||
        (props.illustratedCards && props.illustratedCards.length > 0);
    return (React.createElement(S.MobileNavItem, { tabIndex: props.activeId !== props.id ? -1 : undefined, "data-is-active": props.activeId === props.id, onClick: (e) => {
            e.target !== this ? props.onActivateChange(props.id) : false;
        } },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" }, hasSecondLevel ? (React.createElement(S.MobilePrimaryNavButton, null,
            props.page.text,
            getSvgFromSystem(SystemIcon.ArrowRight))) : (React.createElement(S.MobilePrimaryNavLink, { href: props.page.url, target: props.page.target }, props.page.text))),
        hasSecondLevel && (React.createElement(S.MobileNavSecondLevel, null,
            React.createElement(S.MobileNavSecondLevelIntro, null,
                React.createElement(S.MobileNavSecondLevelHeading, { onClick: (e) => {
                        props.onActivateChange();
                        e.stopPropagation();
                    } },
                    getSvgFromSystem(SystemIcon.ArrowRight),
                    props.page.text),
                props.summary && (React.createElement(S.MobileNavSecondLevelSummary, { dangerouslySetInnerHTML: { __html: props.summary } }))),
            props.sectionLinks && props.sectionLinks.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(S.MobileNavSecondLevelNavLinkList, null, props.sectionLinks.map((link, index) => (React.createElement("li", { key: `mobile-nav-second-level-link-${index}` },
                    React.createElement(S.MobilePrimaryNavLink, { href: link.url, target: link.target }, link.text))))))),
            props.illustratedCards && props.illustratedCards.length > 0 && (React.createElement(S.CardsList, null, props.illustratedCards.map((item, index) => (React.createElement(IllustratedCard, { key: `illustrated-card-${index}`, ...item }))))),
            props.sectionLinks && props.sectionLinks.length > 0 && props.featuredImage && (React.createElement(S.MobileNavFeaturedImage, null, srcs && (React.createElement(S.DropdownMenuImage, { src: srcs.src, srcSet: srcs.srcSet, alt: props.featuredImage.altText, loading: "lazy" }))))))));
};
export default withMotion(MobileNavigation);
